import User from './user';
import UserLink from './user-link';
User.Link = UserLink;
export default User;